import { render, staticRenderFns } from "./HeaderSimple.html?vue&type=template&id=cf535670&scoped=true&"
import script from "./HeaderSimple.js?vue&type=script&lang=js&"
export * from "./HeaderSimple.js?vue&type=script&lang=js&"
import style0 from "./HeaderSimple.scss?vue&type=style&index=0&id=cf535670&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf535670",
  null
  
)

export default component.exports